
import { CommonModule } from '@angular/common';
import { AppMaintenanceComponent } from './app-maintenance.component';
import { NgModule } from '@angular/core';
import { AppMaintenanceRoutingModule } from './app-maintenance-routing.module';

@NgModule({
  declarations: [AppMaintenanceComponent],
  
  imports: [
    CommonModule,
    AppMaintenanceRoutingModule
    
  ],
})
export class AppMaintenanceModule { }
